/** Normalize router pathnames so `/foo` and `/foo/` match the same route. */
export function trimTrailingSlash(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}
